import { useCharger } from './queries/chargerQueries';
import { useStation } from './queries/stationQueries';
import { useDRResource } from './queries/drResourceQueries';
import { useChargingHistoryTimeSlot } from './queries/chargingHistoryQueries';
import { usePeriodChargerStatTwoWeeks, usePeriodChargerStatOneYear } from './queries/periodChargerStatQueries';
import dayjs from 'dayjs';

/**
 * 충전기 데이터를 간결하게 사용하는 헬퍼 훅
 * @param {Object} params - 쿼리 파라미터
 * @returns {Object} 충전기 데이터와 관련 정보
 */
export const useChargerDetail = (id, params = {}) => {
  const { data: chargersData, isLoading: chargersLoading, error } = useCharger(id);
  
  const charger = chargersData || null;
  const stationId = charger?.StationSysId;
  
  const { data: station = null, isLoading: stationsLoading } = useStation(stationId);
  const today = dayjs().format('YYYY-MM-DD');
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
  const { data: chargingHistoryTimeSlot = [], isLoading: chargingHistoryTimeSlotLoading } = useChargingHistoryTimeSlot(id, yesterday);
  const { data: periodChargerStatTwoWeeks = [], isLoading: periodChargerStatTwoWeeksLoading } = usePeriodChargerStatTwoWeeks(id, today);
  const { data: periodChargerStatOneYear = [], isLoading: periodChargerStatOneYearLoading } = usePeriodChargerStatOneYear(id, today);
  
  const { data: drResource = null, isLoading: drResourceLoading } = useDRResource(station?.DrResourceSysId);
  
  // Station 정보를 쉽게 찾을 수 있는 헬퍼 함수
  const getStation = (stationId) => {
    return station;
  };
  // 충전 이력 time slot 정보를 쉽게 찾을 수 있는 헬퍼 함수
  const getChargingHistoryTimeSlot = (chargerId) => {
    return chargingHistoryTimeSlot.find(slot => slot.ChargerSysId === chargerId);
  };
  // 충전 이력 time slot 정보를 쉽게 찾을 수 있는 헬퍼 함수
  const getPeriodChargerStatTwoWeeks = (chargerId) => {
    return periodChargerStatTwoWeeks.find(stat => stat.ChargerSysId === chargerId);
  };
  const getPeriodChargerStatOneYear = (chargerId) => {
    return periodChargerStatOneYear.find(stat => stat.ChargerSysId === chargerId);
  };
  return {
    charger,
    station,
    drResource,
    chargingHistoryTimeSlot,
    periodChargerStatTwoWeeks,
    periodChargerStatOneYear,
    getStation,
    getChargingHistoryTimeSlot,
    getPeriodChargerStatTwoWeeks,
    getPeriodChargerStatOneYear,
    isLoading: chargersLoading || stationsLoading || chargingHistoryTimeSlotLoading || periodChargerStatTwoWeeksLoading || periodChargerStatOneYearLoading || drResourceLoading,
    error,
    // 추가 헬퍼 메서드들
    getChargerById: (chargerId) => charger,
  };
};

export default useChargerDetail;
